// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"0b0e46cb","301":"f0003d10","307":"36cc93e2","388":"5c563c2b","453":"4115d8a0","581":"9ed77def","711":"ab05ae9a","846":"44c5cb80","911":"e38db967","928":"0a2b02ca"}[chunkId] + ".chunk.js";
};